import { render, staticRenderFns } from "./HeaderSecond.vue?vue&type=template&id=86a7e4c8&scoped=true&"
import script from "./HeaderSecond.vue?vue&type=script&lang=js&"
export * from "./HeaderSecond.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSecond.vue?vue&type=style&index=0&id=86a7e4c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a7e4c8",
  null
  
)

export default component.exports